module.exports = __webpack_public_path__ + "img/list_hk_lv1_mainland.5f8a7d7f.png";